module.exports = __webpack_public_path__ + "img/badge.7c6935a0.svg";